import { usePostApply } from '@components/hooks/PostApplyProvider/index.client'
import usePostTrialApplyStepViewedEvent from '@components/hooks/usePostTrialApplyStepViewedEvent'
import EditableMessage from '@components/primitives/EditableMessage'
import { Icon } from '@components/primitives/Icon'
import { faPen } from '@fortawesome/pro-regular-svg-icons/faPen'
import type { ApplySuccessPageProps } from 'app/p/apply-success/[token]/[step]/page'

export default function WhyApplyToTrialPrompt({
  idToken,
}: Pick<ApplySuccessPageProps, 'idToken'>) {
  const { setWhyApplyToTrial, whyApplyToTrial } = usePostApply()
  usePostTrialApplyStepViewedEvent({
    trialApplicationIdToken: idToken,
    type: 'why-apply-to-trial-step',
  })

  return (
    <div className='mx-auto grid max-w-3xl grid-cols-1 items-center gap-8'>
      <div className='mx-auto flex size-24 flex-col items-center justify-center gap-2 rounded-full bg-primary50'>
        <Icon className='text-primary600' icon={faPen} size='2x' />
      </div>
      <h3 className={'text-4xl font-bold text-black'}>
        Tell the study team why you applied
      </h3>
      <EditableMessage
        autoFocus
        className='h-72 w-full rounded-lg !border-neutral100 bg-white p-2 text-lg text-neutral500 md:rounded-lg md:p-6'
        hideEditButton
        onChange={(e) => setWhyApplyToTrial(e.target.value)}
        placeholder={'Let the study team know why you applied to this trial'}
        value={whyApplyToTrial}
        width='80vw'
      />
    </div>
  )
}
